<template><div class="main">
  <sticky-bar @back="$router.push('/s')">
    {{ fleet && fleet.name || 'Loading...' }}
    <small>Fleet Settings</small>
  </sticky-bar>
  <div class="padded scroll links">
    Choose an option:
    <router-link :to="`/s/f/${fid}/u`">Colors</router-link>
    <router-link :to="`/s/f/${fid}/f`">Fault Management Scheme</router-link>
    <router-link :to="`/s/f/${fid}/p`">Points of Interest</router-link>
    <router-link :to="`/s/f/${fid}/s`">Schedule</router-link>
  </div>
</div></template>
<script>
import StickyBar from '../../StickyBar'
export default {
  name: 'settings',
  components: { StickyBar },
  props: { fid: { default: null } },
  computed: {
    fleet() {
      return (this.fid !== null) && this.$store.getters.fleets[this.fid] || null
    },
  },
}
</script>
<style lang="scss" scoped>
.links {
  display: flex;
  flex-direction: column;
  margin-right: auto;
  gap: 10px;
  a {
    display: inline-block;
    padding: 10px 20px;
    border-radius: 10px;
    text-decoration: none;
    background-color: #ccc;
    &:hover { background-color: #ddd; }
  }
}
</style>
